import { cn } from "@/lib/utils";

type StepperProps = {
  className?: string;
  totalSteps: number;
  currentStep: number;
  activeStepClassName?: string;
  completedStepClassName?: string;
  inactiveStepClassName?: string;
  "aria-label"?: string;
};

export default function Stepper({
  className,
  totalSteps,
  currentStep,
  activeStepClassName,
  completedStepClassName,
  inactiveStepClassName,
  "aria-label": ariaLabel,
}: StepperProps) {
  if (totalSteps <= 0) {
    return null;
  }

  const safeCurrentStep = Math.min(Math.max(currentStep, 1), totalSteps);

  return (
    <div
      role="group"
      className={cn("inline-flex items-center gap-2", className)}
      aria-label={ariaLabel ?? `Step ${safeCurrentStep} of ${totalSteps}`}
    >
      {Array.from({ length: totalSteps }, (_, index) => {
        const isActive = index + 1 === safeCurrentStep;
        const isCompleted = index + 1 < safeCurrentStep;

        return (
          <span
            key={index}
            className={cn(
              "block rounded-full transition-colors",
              isActive
                ? "bg-brand h-2 w-6"
                : isCompleted
                  ? "bg-brand/80 size-2"
                  : "size-2 bg-background-neutral-pressed",
              isActive
                ? activeStepClassName
                : isCompleted
                  ? completedStepClassName
                  : inactiveStepClassName,
            )}
            aria-hidden="true"
          />
        );
      })}
    </div>
  );
}
